import { type ImportType } from '@webapp/models/enums'
import { type ImporterSampleData } from '@webapp/platform/_unmigrated/Importer/types'
import { ApiClient, ApiClientV1 } from '@webapp/services/api'
import {
  IMPORT_SAMPLE_DATA_TYPE_ENDPOINT_MAP,
  IMPORT_TYPE_ENDPOINT_MAP,
  IMPROVED_IMPORT_TYPE_ENDPOINT_MAP,
} from './constants'
import {
  type ImporterPayload,
  type ImporterStatusResponse,
  type LegacyImporterSubmitPayload,
  type LegacyImporterSubmitResponse,
} from './types'
import { IMPORT_CATALOG_ITEMS_URL } from '../CatalogItemsAPI'

export const LegacyImportAPI = {
  submit: (type: ImportType, data: LegacyImporterSubmitPayload) => {
    return ApiClientV1.post<any, LegacyImporterSubmitResponse>(
      IMPORT_TYPE_ENDPOINT_MAP[type],
      data
    )
  },
  getSampleData: (type: ImportType, uuid: string) => {
    return ApiClient.post<any, string[][]>(
      IMPORT_SAMPLE_DATA_TYPE_ENDPOINT_MAP[type],
      { csv_file_uuid: uuid }
    )
  },
  submitImproved: (type: ImportType, data: LegacyImporterSubmitPayload) => {
    return ApiClient.post<any, LegacyImporterSubmitResponse>(
      IMPROVED_IMPORT_TYPE_ENDPOINT_MAP[type],
      data
    )
  },
}

export const ImportAPI = {
  getImportPreviewSample: (type: ImportType, uuid: string) => {
    return ApiClient.get<any, ImporterSampleData>(
      `${IMPORT_CATALOG_ITEMS_URL}${uuid}/sample/`
    )
  },
  updateCSVImportFormat: (
    type: ImportType,
    uuid: string,
    data: ImporterPayload
  ) => {
    return ApiClient.put<ImporterPayload, ImporterStatusResponse>(
      `${IMPORT_CATALOG_ITEMS_URL}${uuid}/`,
      data
    )
  },
  getCSVImport: (type: ImportType, uuid: string) => {
    return ApiClient.get<any, ImporterStatusResponse>(
      `${IMPORT_CATALOG_ITEMS_URL}${uuid}/`
    )
  },
}
